import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import { Button, IconButton, Paper, Typography } from '@material-ui/core';

import { BATCH_ACTION_TYPES } from '../../enums/AssetBatchActionTypes';

class BatchDeleteModal extends React.Component {
    onCloseModal = () => {
        this.props.onClose();
    };

    onDeleteAssets = () => {
        const { selectedAssets, executeBatchAction } = this.props;
        executeBatchAction(BATCH_ACTION_TYPES.DELETE, selectedAssets, {});
    };

    render() {
        const {
            show,
            classes,
            selectedAssets,
        } = this.props;

        if (!show) {
            return null;
        }

        const selectedItemsCount = selectedAssets.length;

        return (
            <div className={classes.container}>
                <Paper className={classes.modal}>
                    <div className={classes.header}>
                        <Typography className={classes.title} variant="title">
                            Delete ({selectedItemsCount} items selected)
                        </Typography>
                        <IconButton
                            aria-label="Close modal"
                            onClick={this.onCloseModal}
                        >
                            x
                        </IconButton>
                    </div>

                    <div className={classes.content}>
                        <Typography variant="body1">
                            Are you sure you want to delete the selected assets? This action cannot be undone.
                        </Typography>
                    </div>

                    <div className={classes.footer}>
                        <Button
                            onClick={this.onCloseModal}
                            color="default"
                            className={classes.cancelButton}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={this.onDeleteAssets}
                            variant="contained"
                            color="secondary"
                        >
                            Delete
                        </Button>
                    </div>
                </Paper>
                <div
                    className={classes.background}
                    onClick={this.onCloseModal}
                />
            </div>
        );
    }
}

BatchDeleteModal.propTypes = {
    show: PropTypes.bool,
    selectedAssets: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    executeBatchAction: PropTypes.func.isRequired,
};

BatchDeleteModal.defaultProps = {
    show: false,
};

const style = ({ palette, spacing }) => ({
    container: {
        width: 0,
        height: 0,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px',
        borderBottom: `1px solid ${palette.background.gray2Color}`,
    },
    title: {
        lineHeight: '1.8em',
    },
    content: {
        padding: '24px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '15px',
        borderTop: `1px solid ${palette.background.gray2Color}`,
    },
    cancelButton: {
        marginRight: spacing.unit,
    },
    background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: 'rgba(0, 0, 0, 0.5)',
    },
    modal: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: '50%',
        maxWidth: '550px',
        minWidth: '300px',
        transform: 'translate(-50%, -50%)',
        zIndex: 128,
    },
});

export default injectSheet(style)(BatchDeleteModal); 


// WEBPACK FOOTER //
// ./src/components/modals/BatchDeleteModal.js